export const FilterByStatus = [
  {
    name: "Approved",
    filter: 0,
  },
  {
    name: "Pending",
    filter: 1,
  },
  // {
  //   name: "Declined",
  //   filter: 7,
  // },
  {
    name: "Rejected",
    filter: 4,
  },
];
export const FilterObjectiveByStatus = [
  {
    name: "Approved",
    filter: 0,
  },
  {
    name: "Pending",
    filter: 1,
  },
  {
    name: "Declined",
    filter: 7,
  },
];

export const LineManagerFilterStatus = [
  {
    name: "Approved",
    filter: 0,
  },
  {
    name: "Pending",
    filter: 1,
  },
  {
    name: "Declined",
    filter: 7,
  },
  {
    name: "Approval By MD",
    filter: 10,
  },
  {
    name: "Approval By HR",
    filter: 20,
  },
  {
    name: "Approval By EDO",
    filter: 30,
  },
  {
    name: "Approval By HOU",
    filter: 40,
  },
  {
    name: "Approval By HOD",
    filter: 50,
  },
  {
    name: "Approval By EDFI",
    filter: 60,
  },
  {
    name: "Reject By MD",
    filter: 3,
  },
  {
    name: "Reject By EDO",
    filter: 9,
  },
  {
    name: "Reject By EDFI",
    filter: 27,
  },
  {
    name: "Reject By HR",
    filter: 81,
  },
  {
    name: "Reject By HOD",
    filter: 243,
  },
  {
    name: "Reject By HOU",
    filter: 729,
  },
  {
    name: "Approved By Control Reviewer",
    filter: 101,
  },
  {
    name: "Approved By Control Approver",
    filter: 102,
  },
  {
    name: "Rejected By Control",
    filter: 104,
  },
];

export const AppraisalPeriodEnum = [
  { name: "Daily", filter: 1 },
  { name: "Weekly", filter: 2 },
  { name: "Monthly", filter: 3 },
  { name: "Quarterly", filter: 4 },
  { name: "BiAnnual", filter: 5 },
  { name: "Yearly", filter: 6 },
];

export const KRATaskType = [
  {
    name: "Core Activity",
    filter: 1,
  },
  {
    name: "Non-Core Activity",
    filter: 2,
  },
];
